import React from "react";


export default {
  'CategoryDropdown.Wrapper.Header': async ({ isOpen, dropdownRef }, _, internalStateSetter) => {
    let newRef = dropdownRef;

    if (!newRef?.current) {
      newRef = React.createRef();
      await internalStateSetter({ dropdownRef: newRef })
    }
    await internalStateSetter('isOpen', !isOpen);
  },
  'CategoryDropdown.Wrapper.Body.Children': ({ child }, outlet, internalStateSetter) => {
    outlet({ categoryId: child.id });
    internalStateSetter('isOpen', false);
  },
}
